<div class="inner-container mt-5">
    <div class="bg-white final-receipt-page section-gap">
       <div class="account-info">
          <div class="container">
             <div class="user-info">
                <div fxLayoutAlign="flex-start">
                   <div class="login-user-img">
                     <img src="assets/images/user-edit.png" width="70" alt="Active User">
                   </div>
                   <div class="px-3">
                     <h4 >{{'REGISTER.HELLO' | translate}}, {{userLogged?.name}}</h4>
                     <div class="text-muted text-xl">{{userLogged?.email}}</div>
                   </div>
                </div>
             </div>
             <div fxLayout="row wrap" class="col-gap mx-0">
                <div fxFlex.xs="100" fxFlex.sm="100" fxFlex.md="30" fxFlex.lg="20" fxFlex.xl="20" class="user-nav-list">
                   <mat-list role="list">
                     <mat-list-item role="listitem">
                        <a [routerLink]="['/auth/account/profile']" routerLinkActive="tab-active">
                            <span>
                               <i class="material-icons">account_circle</i>{{'PROFILE.PROFILE' | translate}}
                           </span>
                         </a>
                      </mat-list-item>
                      <mat-list-item role="listitem"> 
                         <a [routerLink]="['/auth/account/myfarms']" routerLinkActive="tab-active">
                            <i class="material-icons">location_on</i> 
                            <span>{{'PROFILE.FARMS' | translate}}</span> 
                         </a>
                      </mat-list-item>
                   </mat-list>
                </div>
                <div fxFlex.xs="100" fxFlex.sm="100" fxFlex.md="70" fxFlex.lg="80" fxFlex.xl="80" class="user-content-wrapper">
                   <div class="tab-container">
                     <router-outlet></router-outlet>
                   </div>
                </div>
             </div>
          </div>
       </div>
    </div>
 </div>
 